import { NgModule } from '@angular/core';

import { VgHlsComponent } from './VgHls.Component';
import { VgHlsSupportService } from './VgHlsSupport.Service';

const components = [
	VgHlsComponent
];

@NgModule({
	declarations: components,
	exports: components,
	providers: [
		VgHlsSupportService
	]
})
export class VgHlsModule {}
